import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';

import { Navigation } from './components/Navigation';
import { ScrollToTop } from './components/ScrollToTop';
import { PlatformProvider } from './contexts/PlatformContext';
import { HomePage } from './pages/HomePage';
import { StepPage } from './pages/StepPage';

const App = () => {
  return (
    <PlatformProvider>
      <Router>
        <ScrollToTop />
        <div className='page-container'>
          <Navigation />
          <Routes>
            <Route path='/' element={<HomePage />} />
            <Route path='/:stepId' element={<StepPage />} />
          </Routes>
        </div>
      </Router>
    </PlatformProvider>
  );
};

export default App;
